/**
 * Cart gate for the six-piece arrangement minimum per collection.
 * Mixing collections does not combine toward the minimum.
 * Wishlist add-to-cart is blocked for these arrangement products.
 */
(function () {
  if (window.__cartMinimumGateLoaded) return;
  window.__cartMinimumGateLoaded = true;

  var MIN_PIECES = 6;

  // Exact approved arrangement product IDs, mapped to collection.
  var PRODUCT_COLLECTIONS = {
    // Antique Garden
    8901891883096: "Antique Garden",
    8902083379288: "Antique Garden",
    8902145441880: "Antique Garden",
    8902143443032: "Antique Garden",
    8902148259928: "Antique Garden",
    8902146261080: "Antique Garden",
    8902148030552: "Antique Garden",
    8941362217048: "Antique Garden",
    8902150029400: "Antique Garden",

    // Modern Hydrangea
    8902320160856: "Modern Hydrangea",
    8902332252248: "Modern Hydrangea",
    8902343983192: "Modern Hydrangea",
    8902340149336: "Modern Hydrangea",
    8902363250776: "Modern Hydrangea",
    8902346473560: "Modern Hydrangea",
    8902359023704: "Modern Hydrangea",
    9045286125656: "Modern Hydrangea",
    8902364397656: "Modern Hydrangea",

    // Blushing Hydrangea
    8903585955928: "Blushing Hydrangea",
    8903593853016: "Blushing Hydrangea",
    8903608762456: "Blushing Hydrangea",
    8903594442840: "Blushing Hydrangea",
    8903646511192: "Blushing Hydrangea",
    8903610040408: "Blushing Hydrangea",
    8903626260568: "Blushing Hydrangea",
    8941361070168: "Blushing Hydrangea",
    8903647592536: "Blushing Hydrangea",

    // Coastal Hydrangea
    8903651852376: "Coastal Hydrangea",
    8903655293016: "Coastal Hydrangea",
    8903657324632: "Coastal Hydrangea",
    8903656341592: "Coastal Hydrangea",
    8903660437592: "Coastal Hydrangea",
    8903658537048: "Coastal Hydrangea",
    8903659749464: "Coastal Hydrangea",
    8941357498456: "Coastal Hydrangea",
    8903660666968: "Coastal Hydrangea",

    // Summer Green
    8903663059032: "Summer Green",
    8903664238680: "Summer Green",
    8903671021656: "Summer Green",
    8903665057880: "Summer Green",
    8903668793432: "Summer Green",
    8903665352792: "Summer Green",
    8903666040920: "Summer Green",
    8941351665752: "Summer Green",
    8903670759512: "Summer Green",

    // Buttercream
    8903671939160: "Buttercream",
    8903673708632: "Buttercream",
    8903676166232: "Buttercream",
    8903674298456: "Buttercream",
    8903675084888: "Buttercream",
    8903674658904: "Buttercream",
    8903674986584: "Buttercream",
    8941342851160: "Buttercream",
    8903675674712: "Buttercream",

    // Natural Green and Cream
    8903728201816: "Natural Green and Cream",
    8903748157528: "Natural Green and Cream",
    8903775846488: "Natural Green and Cream",
    8903751139416: "Natural Green and Cream",
    8903771914328: "Natural Green and Cream",
    8903754514520: "Natural Green and Cream",
    8903767359576: "Natural Green and Cream",
    8941304414296: "Natural Green and Cream",
    8903773978712: "Natural Green and Cream",

    // Champagne Neutrals
    8903677673560: "Champagne Neutrals",
    8903678820440: "Champagne Neutrals",
    8903688749144: "Champagne Neutrals",
    8903685767256: "Champagne Neutrals",
    8903688323160: "Champagne Neutrals",
    8903686389848: "Champagne Neutrals",
    8903687831640: "Champagne Neutrals",
    8941328433240: "Champagne Neutrals",
    8903688552536: "Champagne Neutrals",

    // Blue and Buttercream
    8904612741208: "Blue and Buttercream",
    8904612872280: "Blue and Buttercream",
    8904609529944: "Blue and Buttercream",
    8904612085848: "Blue and Buttercream",
    8904613822552: "Blue and Buttercream",
    8904613134424: "Blue and Buttercream",
    8904613691480: "Blue and Buttercream",
    8941301366872: "Blue and Buttercream",
    8904614084696: "Blue and Buttercream",

    // Cream and Sage
    8904604811352: "Cream and Sage",
    8904605040728: "Cream and Sage",
    8904457125976: "Cream and Sage",
    8912629366872: "Cream and Sage",
    8904597897304: "Cream and Sage",
    8904581677144: "Cream and Sage",
    8904594686040: "Cream and Sage",
    8941301694552: "Cream and Sage",
    8904599306328: "Cream and Sage",

    // Autumnal
    8903692910680: "Autumnal",
    8903694155864: "Autumnal",
    8903696089176: "Autumnal",
    8903694385240: "Autumnal",
    8903695859800: "Autumnal",
    8903695695960: "Autumnal",
    8903695794264: "Autumnal",
    8941318111320: "Autumnal",
    8903695958104: "Autumnal",

    // Autumn Wildflower
    8903697465432: "Autumn Wildflower",
    8903704281176: "Autumn Wildflower",
    8903715094616: "Autumn Wildflower",
    8903707459672: "Autumn Wildflower",
    8903713882200: "Autumn Wildflower",
    8903709392984: "Autumn Wildflower",
    8903712014424: "Autumn Wildflower",
    8941309919320: "Autumn Wildflower",
    8903714340952: "Autumn Wildflower",

    // Modern Muse
    8904655372376: "Modern Muse",
    8904667431000: "Modern Muse",
    8904681128024: "Modern Muse",
    8904671527000: "Modern Muse",
    8904673034328: "Modern Muse",
    8904676507736: "Modern Muse",
    8904679325784: "Modern Muse",
    8941301104728: "Modern Muse",
    8904680276056: "Modern Muse",

    // Midnight Garden
    8909803815000: "Midnight Garden",
    8917801435224: "Midnight Garden",
    8917813821528: "Midnight Garden",
    8917802745944: "Midnight Garden",
    8917812871256: "Midnight Garden",
    8917810380888: "Midnight Garden",
    8917812445272: "Midnight Garden",
    8941299400792: "Midnight Garden",
    8917813002328: "Midnight Garden",

    // Peach Blossom
    8917816967256: "Peach Blossom",
    8917823881304: "Peach Blossom",
    8917842624600: "Peach Blossom",
    8917831909464: "Peach Blossom",
    8917839052888: "Peach Blossom",
    8917834596440: "Peach Blossom",
    8917837676632: "Peach Blossom",
    8941298286680: "Peach Blossom",
    8917840822360: "Peach Blossom",

    // Wildflower
    8917858222168: "Wildflower",
    8917903867992: "Wildflower",
    8917928607832: "Wildflower",
    8917909897304: "Wildflower",
    8917924773976: "Wildflower",
    8917915762776: "Wildflower",
    8917923037272: "Wildflower",
    8941297139800: "Wildflower",
    8917926379608: "Wildflower",

    // Cherry Red
    8918027305048: "Cherry Red",
    8918034022488: "Cherry Red",
    8918040412248: "Cherry Red",
    8918038675544: "Cherry Red",
    8918039986264: "Cherry Red",
    8918038970456: "Cherry Red",
    8918039593048: "Cherry Red",
    8941287276632: "Cherry Red",
    8918040084568: "Cherry Red",

    // Golden Hour
    8918048243800: "Golden Hour",
    8918049128536: "Golden Hour",
    8918060302424: "Golden Hour",
    8918051618904: "Golden Hour",
    8918058631256: "Golden Hour",
    8918056370264: "Golden Hour",
    8918057910360: "Golden Hour",
    8941274955864: "Golden Hour",
    8918059483224: "Golden Hour",

    // Scarlet
    8918042280024: "Scarlet",
    8918042837080: "Scarlet",
    8918041329752: "Scarlet",
    8918043033688: "Scarlet",
    8918043983960: "Scarlet",
    8918043328600: "Scarlet",
    8918043754584: "Scarlet",
    8941279641688: "Scarlet",
    8918044082264: "Scarlet",

    // Color Crush
    8918063480920: "Color Crush",
    8918068789336: "Color Crush",
    8918075998296: "Color Crush",
    8918069903448: "Color Crush",
    8918074130520: "Color Crush",
    8918071083096: "Color Crush",
    8918073016408: "Color Crush",
    8941269680216: "Color Crush",
    8918074720344: "Color Crush",

    // Terracotta
    8922405273688: "Terracotta",
    8922427916376: "Terracotta",
    8922453246040: "Terracotta",
    8922438959192: "Terracotta",
    8922462224472: "Terracotta",
    8922454523992: "Terracotta",
    8922459439192: "Terracotta",
    8941216727128: "Terracotta",
    8922464288856: "Terracotta",

    // Tropical Sunset
    8922471006296: "Tropical Sunset",
    8922472022104: "Tropical Sunset",
    8922475331672: "Tropical Sunset",
    8922474283096: "Tropical Sunset",
    8922477428824: "Tropical Sunset",
    8922476052568: "Tropical Sunset",
    8922476806232: "Tropical Sunset",
    8941215219800: "Tropical Sunset",
    8922478084184: "Tropical Sunset",

    // Pastel Garden
    8922346422360: "Pastel Garden",
    8922362380376: "Pastel Garden",
    8922385154136: "Pastel Garden",
    8922371588184: "Pastel Garden",
    8922381451352: "Pastel Garden",
    8922377879640: "Pastel Garden",
    8922380763224: "Pastel Garden",
    8941265223768: "Pastel Garden",
    8922383024216: "Pastel Garden",

    // Blush and Cream
    8922480803928: "Blush and Cream",
    8922488111192: "Blush and Cream",
    8922488963160: "Blush and Cream",
    8922488537176: "Blush and Cream",
    8922492993624: "Blush and Cream",
    8922489618520: "Blush and Cream",
    8922492633176: "Blush and Cream",
    8941214531672: "Blush and Cream",
    8922493288536: "Blush and Cream",

    // Meadow White
    8923981381720: "Meadow White",
    8924833579096: "Meadow White",
    8924855599192: "Meadow White",
    8924842197080: "Meadow White",
    8924889186392: "Meadow White",
    8924869918808: "Meadow White",
    8924883451992: "Meadow White",
    8941211615320: "Meadow White",
    8924894658648: "Meadow White",

    // French Blue
    8924941975640: "French Blue",
    8925006561368: "French Blue",
    8925023961176: "French Blue",
    8925013311576: "French Blue",
    8925116104792: "French Blue",
    8925099393112: "French Blue",
    8925109977176: "French Blue",
    8941209288792: "French Blue",
    8925120233560: "French Blue",

    // Blush and Blue
    8936934735960: "Blush and Blue",
    8936961278040: "Blush and Blue",
    8936988377176: "Blush and Blue",
    8936979071064: "Blush and Blue",
    8937025798232: "Blush and Blue",
    8936995487832: "Blush and Blue",
    8937015509080: "Blush and Blue",
    8941208764504: "Blush and Blue",
    8937028419672: "Blush and Blue",

    // Blush and Plum
    8937210576984: "Blush and Plum",
    8937214345304: "Blush and Plum",
    8937218670680: "Blush and Plum",
    8937215754328: "Blush and Plum",
    8937225519192: "Blush and Plum",
    8937220309080: "Blush and Plum",
    8937224241240: "Blush and Plum",
    8941016612952: "Blush and Plum",
    8937226633304: "Blush and Plum",

    // Jewel Tones
    8938419224664: "Jewel Tones",
    8938427154520: "Jewel Tones",
    8938437378136: "Jewel Tones",
    8938432692312: "Jewel Tones",
    8938444456024: "Jewel Tones",
    8938440818776: "Jewel Tones",
    8938443407448: "Jewel Tones",
    8941001932888: "Jewel Tones",
    8938445307992: "Jewel Tones",

    // The Green Edit
    8938517332056: "The Green Edit",
    8938518511704: "The Green Edit",
    8938518970456: "The Green Edit",
    8938518872152: "The Green Edit",
    8938519789656: "The Green Edit",
    8938519298136: "The Green Edit",
    8938519560280: "The Green Edit",
    8940977651800: "The Green Edit",
    8938519953496: "The Green Edit",

    // Soft Pink and Cream Garden Rose
    8938463297624: "Soft Pink and Cream Garden Rose",
    8938469818456: "Soft Pink and Cream Garden Rose",
    8938470244440: "Soft Pink and Cream Garden Rose",
    8938470178904: "Soft Pink and Cream Garden Rose",
    8938470834264: "Soft Pink and Cream Garden Rose",
    8938470441048: "Soft Pink and Cream Garden Rose",
    8938470670424: "Soft Pink and Cream Garden Rose",
    8940993511512: "Soft Pink and Cream Garden Rose",
    8938471620696: "Soft Pink and Cream Garden Rose",

    // Ivory Garden Rose
    8938495246424: "Ivory Garden Rose",
    8938491740248: "Ivory Garden Rose",
    8938488823896: "Ivory Garden Rose",
    8938486300760: "Ivory Garden Rose",
    8938476798040: "Ivory Garden Rose",
    8938484858968: "Ivory Garden Rose",
    8938484629592: "Ivory Garden Rose",
    8940991414360: "Ivory Garden Rose",
    8938473914456: "Ivory Garden Rose",

    // Blue and Cream Garden Rose
    8938497769560: "Blue and Cream Garden Rose",
    8938499407960: "Blue and Cream Garden Rose",
    8938508157016: "Blue and Cream Garden Rose",
    8938507763800: "Blue and Cream Garden Rose",
    8938509271128: "Blue and Cream Garden Rose",
    8938508714072: "Blue and Cream Garden Rose",
    8938508976216: "Blue and Cream Garden Rose",
    8940989022296: "Blue and Cream Garden Rose",
    8938509402200: "Blue and Cream Garden Rose",

    // Peach Garden Rose
    8938510024792: "Peach Garden Rose",
    8938510483544: "Peach Garden Rose",
    8938510942296: "Peach Garden Rose",
    8938510778456: "Peach Garden Rose",
    8938514219096: "Peach Garden Rose",
    8938512056408: "Peach Garden Rose",
    8938512384088: "Peach Garden Rose",
    8940985581656: "Peach Garden Rose",
    8938515923032: "Peach Garden Rose",

    // Sunset Garden Rose
    8938598006872: "Sunset Garden Rose",
    8938596925528: "Sunset Garden Rose",
    8938596335704: "Sunset Garden Rose",
    8938595942488: "Sunset Garden Rose",
    8938592731224: "Sunset Garden Rose",
    8938595549272: "Sunset Garden Rose",
    8938594205784: "Sunset Garden Rose",
    8940951535704: "Sunset Garden Rose",
    8938590961752: "Sunset Garden Rose",

    // Deep Pink Garden Rose
    8939901288536: "Deep Pink Garden Rose",
    8939901485144: "Deep Pink Garden Rose",
    8939902369880: "Deep Pink Garden Rose",
    8939902074968: "Deep Pink Garden Rose",
    8939902828632: "Deep Pink Garden Rose",
    8939902500952: "Deep Pink Garden Rose",
    8939902599256: "Deep Pink Garden Rose",
    8940948848728: "Deep Pink Garden Rose",
    8939903058008: "Deep Pink Garden Rose",

    // Pink Palette
    8938521821272: "Pink Palette",
    8938523066456: "Pink Palette",
    8938524180568: "Pink Palette",
    8938523394136: "Pink Palette",
    8938526179416: "Pink Palette",
    8938524934232: "Pink Palette",
    8938525458520: "Pink Palette",
    8940960809048: "Pink Palette",
    8938526343256: "Pink Palette",

    // Lavender and Lace
    8938527293528: "Lavender and Lace",
    8938527588440: "Lavender and Lace",
    8938528211032: "Lavender and Lace",
    8938528047192: "Lavender and Lace",
    8938541514840: "Lavender and Lace",
    8938528604248: "Lavender and Lace",
    8938541318232: "Lavender and Lace",
    8940957565016: "Lavender and Lace",
    8938541744216: "Lavender and Lace",

    // Peaches and Cream
    8938565763160: "Peaches and Cream",
    8938583916632: "Peaches and Cream",
    8938586898520: "Peaches and Cream",
    8938585948248: "Peaches and Cream",
    8938588569688: "Peaches and Cream",
    8938587455576: "Peaches and Cream",
    8938588209240: "Peaches and Cream",
    8940953206872: "Peaches and Cream",
    8938589225048: "Peaches and Cream",

    // Peach and Blue
    8939907579992: "Peach and Blue",
    8939909087320: "Peach and Blue",
    8939906924632: "Peach and Blue",
    8939906662488: "Peach and Blue",
    8939905253464: "Peach and Blue",
    8939906433112: "Peach and Blue",
    8939906236504: "Peach and Blue",
    8940944785496: "Peach and Blue",
    8939904434264: "Peach and Blue",
  };

  var WISHLIST_NOTICE =
    "Arrangement pieces must be added from their collection page, not from your wishlist.";

  var state = {
    blocked: false,
    pieces: 0,
    hasQualifying: false,
    shortfalls: [],
  };

  function collectionForProductId(productId) {
    if (!productId) return null;
    return PRODUCT_COLLECTIONS[productId] || PRODUCT_COLLECTIONS[String(productId)] || null;
  }

  function isQualifyingItem(item) {
    return Boolean(item && collectionForProductId(item.product_id));
  }

  function piecesForItem(item) {
    var perUnit = 1;
    var match = /^\s*(\d+)/.exec(item.variant_title || "");
    if (match) perUnit = parseInt(match[1], 10) || 1;
    return perUnit * (item.quantity || 0);
  }

  function evaluateCart(cart) {
    var piecesByCollection = {};
    var collectionOrder = [];
    var pieces = 0;
    var hasQualifying = false;
    var items = (cart && cart.items) || [];
    var i;

    for (i = 0; i < items.length; i++) {
      var item = items[i];
      var collection = collectionForProductId(item && item.product_id);
      if (!collection) continue;
      hasQualifying = true;
      var itemPieces = piecesForItem(item);
      pieces += itemPieces;
      if (!piecesByCollection[collection]) {
        collectionOrder.push(collection);
        piecesByCollection[collection] = 0;
      }
      piecesByCollection[collection] += itemPieces;
    }

    var shortfalls = [];
    for (i = 0; i < collectionOrder.length; i++) {
      var name = collectionOrder[i];
      if (piecesByCollection[name] < MIN_PIECES) {
        shortfalls.push({ name: name, pieces: piecesByCollection[name] });
      }
    }

    state.hasQualifying = hasQualifying;
    state.pieces = pieces;
    state.shortfalls = shortfalls;
    state.blocked = shortfalls.length > 0;
    return state;
  }

  function messageText() {
    var shortfalls = state.shortfalls || [];
    if (!shortfalls.length) {
      return (
        "Please add at least " +
        MIN_PIECES +
        " arrangement pieces from the same collection before checking out."
      );
    }
    if (shortfalls.length === 1) {
      return (
        "Please add at least " +
        MIN_PIECES +
        " " +
        shortfalls[0].name +
        " arrangement pieces before checking out. You currently have " +
        shortfalls[0].pieces +
        "."
      );
    }

    var parts = [];
    var i;
    for (i = 0; i < shortfalls.length; i++) {
      parts.push(shortfalls[i].name + ": " + shortfalls[i].pieces + " of " + MIN_PIECES);
    }
    return (
      "Each collection in your cart needs at least " +
      MIN_PIECES +
      " arrangement pieces before checkout. " +
      parts.join(". ") +
      "."
    );
  }

  function ensureCheckoutWrap(button) {
    if (!button) return null;
    var wrap = button.closest(".ag-min-checkout-wrap");
    if (wrap) return wrap;

    wrap = document.createElement("div");
    wrap.className = "ag-min-checkout-wrap";
    button.parentNode.insertBefore(wrap, button);
    wrap.appendChild(button);

    var hitbox = document.createElement("button");
    hitbox.type = "button";
    hitbox.className = "ag-min-checkout-hitbox";
    hitbox.setAttribute("aria-label", "Checkout blocked. See minimum message.");
    hitbox.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      flashBlocked(wrap);
    });
    wrap.appendChild(hitbox);

    return wrap;
  }

  function getCheckoutButtons() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '[data-cart-page] button[name="checkout"].cart__checkout, [data-cart-drawer] button[name="checkout"].cart__checkout'
      )
    );
  }

  function getExpressBlocks() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        "[data-cart-page] .additional-checkout-buttons, [data-cart-drawer] .additional-checkout-buttons, [data-cart-page] .cart__or"
      )
    );
  }

  function getGates() {
    return Array.prototype.slice.call(document.querySelectorAll("[data-ag-min-gate]"));
  }

  function applyUi() {
    var gates = getGates();
    var buttons = getCheckoutButtons();
    var expressBlocks = getExpressBlocks();
    var i;

    for (i = 0; i < gates.length; i++) {
      var gate = gates[i];
      var textEl = gate.querySelector("[data-ag-min-text]");
      var nextMessage = messageText();
      if (textEl && textEl.textContent !== nextMessage) {
        textEl.textContent = nextMessage;
      }
      gate.classList.toggle("is-visible", state.blocked);
      if (gate.hidden === state.blocked) {
        gate.hidden = !state.blocked;
      }
      if (!state.blocked) gate.classList.remove("is-attention");
    }

    for (i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var wrap = ensureCheckoutWrap(button);
      if (!wrap) continue;

      // Avoid the native `disabled` attribute: Broadcast re-enables all cart
      // buttons after AJAX updates. Use a hitbox + submit guard instead.
      wrap.classList.toggle("is-blocked", state.blocked);
      if (state.blocked) {
        button.setAttribute("aria-disabled", "true");
        button.setAttribute("tabindex", "-1");
      } else {
        button.removeAttribute("aria-disabled");
        button.removeAttribute("tabindex");
        wrap.classList.remove("is-shaking");
      }
    }

    for (i = 0; i < expressBlocks.length; i++) {
      expressBlocks[i].classList.toggle("ag-min-express-hidden", state.blocked);
    }
  }

  function flashBlocked(originWrap) {
    if (!state.blocked) return;

    var gates = getGates();
    var wraps = [];
    var buttons = getCheckoutButtons();
    var i;

    for (i = 0; i < buttons.length; i++) {
      var wrap = ensureCheckoutWrap(buttons[i]);
      if (wrap) wraps.push(wrap);
    }

    if (originWrap && wraps.indexOf(originWrap) === -1) wraps.push(originWrap);

    for (i = 0; i < wraps.length; i++) {
      wraps[i].classList.remove("is-shaking");
      void wraps[i].offsetWidth;
      wraps[i].classList.add("is-shaking");
    }

    for (i = 0; i < gates.length; i++) {
      var gate = gates[i];
      if (!gate.classList.contains("is-visible")) continue;
      gate.classList.remove("is-attention");
      void gate.offsetWidth;
      gate.classList.add("is-attention");
      try {
        gate.scrollIntoView({ behavior: "smooth", block: "nearest" });
      } catch (e) {
        /* ignore */
      }
    }
  }

  function bindFormGuards() {
    var forms = document.querySelectorAll(
      "[data-cart-page] form.cart__form, [data-cart-drawer] form.cart__form"
    );

    Array.prototype.forEach.call(forms, function (form) {
      if (form.__cartMinimumGateBound) return;
      form.__cartMinimumGateBound = true;

      form.addEventListener(
        "submit",
        function (event) {
          if (!state.blocked) return;

          var submitter = event.submitter;
          var isCheckout =
            !submitter ||
            submitter.getAttribute("name") === "checkout" ||
            (submitter.classList && submitter.classList.contains("cart__checkout"));

          if (!isCheckout) return;

          event.preventDefault();
          event.stopPropagation();
          flashBlocked(submitter && submitter.closest(".ag-min-checkout-wrap"));
        },
        true
      );
    });
  }

  function refresh() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Cart fetch failed");
        return response.json();
      })
      .then(function (cart) {
        evaluateCart(cart);
        bindFormGuards();
        applyUi();
      })
      .catch(function () {
        /* fail open for UX; Shopify Function still guards checkout */
      });
  }

  function onAnimationEnd(event) {
    if (event.animationName !== "ag-min-nudge") return;
    var target = event.target;
    if (!target || !target.classList) return;
    target.classList.remove("is-shaking");
    target.classList.remove("is-attention");
  }

  var ARRANGEMENT_HANDLE_HINTS = [
    "-bridal-bouquet",
    "-bridesmaid-bouquet",
    "-bud-vases-set-of-20",
    "-compote-centerpiece",
    "-grounded-ceremony-arrangement",
    "-large-aisle-marker-arrangement",
    "-large-ceremony-pillar-arrangement",
    "-large-ceremony-urn-arrangement",
  ];

  function isArrangementHandle(handle) {
    if (!handle) return false;
    var i;
    for (i = 0; i < ARRANGEMENT_HANDLE_HINTS.length; i++) {
      if (handle.indexOf(ARRANGEMENT_HANDLE_HINTS[i]) !== -1) return true;
    }
    return false;
  }

  function arrangementFromWishlistItem(el) {
    var node = el;
    var hops = 0;
    while (node && hops < 12) {
      if (node.querySelector) {
        var link = node.querySelector('a[href*="/products/"]');
        var href = (link && link.getAttribute("href")) || "";
        var match = href.match(/\/products\/([^/?#]+)/);
        if (isArrangementHandle(match && match[1])) return true;
      }
      node = node.parentElement;
      hops += 1;
    }
    return false;
  }

  function parseProductId(value) {
    if (value == null || value === "") return 0;
    var n = parseInt(String(value).replace(/[^\d]/g, ""), 10);
    return n || 0;
  }

  function readAttr(el, names) {
    if (!el || !el.getAttribute) return "";
    var i;
    for (i = 0; i < names.length; i++) {
      var value = el.getAttribute(names[i]);
      if (value) return value;
    }
    if (el.dataset) {
      if (el.dataset.productId) return el.dataset.productId;
      if (el.dataset.empi) return el.dataset.empi;
      if (el.dataset.productid) return el.dataset.productid;
    }
    return "";
  }

  var PRODUCT_ID_ATTRS = [
    "data-product-id",
    "data-empi",
    "empi",
    "data-productid",
    "data-productId",
  ];

  function productIdFromElement(el) {
    var node = el;
    var hops = 0;
    while (node && hops < 8) {
      var raw = readAttr(node, PRODUCT_ID_ATTRS);
      var parsed = parseProductId(raw);
      if (parsed) return parsed;
      node = node.parentElement;
      hops += 1;
    }
    return 0;
  }

  function isWishlistContext(el) {
    if (!el || !el.closest) return false;
    return Boolean(
      el.closest(
        ".swym-ui-component, .swym-wishlist-grid, .swym-wishlist-item, .swym-wishlist-card, .swym-modal, .swym-wishlist-container, #wishlist-items-container, .hulk__wishlist-wrap, .wishlist-popup, [data-hulkappsMyWishlistPopup], [data-hulkappsMyWishlistDrawer], [data-hulkappsWishlistPopup], .swym-sfl-container, .swym-htc-container"
      )
    );
  }

  function isWishlistAddControl(el) {
    if (!el || !el.closest) return false;
    return Boolean(
      el.closest(
        ".swym-add-to-cart-btn, .swym-add-all-to-cart-btn, .swym-sfl-add-to-cart-btn, .swym-sfl-add-all-to-cart-btn, .swym-wishlist-cart-btn, [data-addprotocart], [data-hulkmoveallitmes], [data-swaction='addToCart']"
      )
    );
  }

  function isWishlistAddAllControl(el) {
    if (!el || !el.closest) return false;
    return Boolean(
      el.closest(
        ".swym-add-all-to-cart-btn, .swym-sfl-add-all-to-cart-btn, [data-hulkmoveallitmes]"
      )
    );
  }

  function wishlistHasQualifyingItem() {
    var nodes = document.querySelectorAll(
      ".swym-wishlist-item, .swym-wishlist-card, .wishlist-grid-view [data-product-id], [data-empi], [data-addprotocart]"
    );
    var i;
    for (i = 0; i < nodes.length; i++) {
      if (collectionForProductId(productIdFromElement(nodes[i]))) return true;
      if (arrangementFromWishlistItem(nodes[i])) return true;
    }
    return false;
  }

  function showWishlistNotice() {
    var notice = document.querySelector(".ag-min-wishlist-notice");
    if (!notice) {
      notice = document.createElement("div");
      notice.className = "ag-min-wishlist-notice";
      notice.setAttribute("role", "status");
      document.body.appendChild(notice);
    }
    notice.textContent = WISHLIST_NOTICE;
    notice.classList.add("is-visible");
    clearTimeout(showWishlistNotice._timer);
    showWishlistNotice._timer = setTimeout(function () {
      notice.classList.remove("is-visible");
    }, 5000);
  }

  function lockWishlistButtons() {
    var buttons = document.querySelectorAll(
      ".swym-add-to-cart-btn, .swym-wishlist-cart-btn, .swym-sfl-add-to-cart-btn, [data-addprotocart]"
    );
    var i;
    for (i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var productId = productIdFromElement(button);
      var blocked =
        Boolean(productId && collectionForProductId(productId)) ||
        arrangementFromWishlistItem(button);
      button.classList.toggle("ag-min-wishlist-blocked", blocked);
      if (blocked) {
        button.setAttribute("aria-disabled", "true");
        button.setAttribute("disabled", "true");
      }
    }

    var addAllBlocked = wishlistHasQualifyingItem();
    var addAll = document.querySelectorAll(
      ".swym-add-all-to-cart-btn, .swym-sfl-add-all-to-cart-btn, [data-hulkmoveallitmes]"
    );
    for (i = 0; i < addAll.length; i++) {
      addAll[i].classList.toggle("ag-min-wishlist-blocked", addAllBlocked);
      if (addAllBlocked) {
        addAll[i].setAttribute("aria-disabled", "true");
      }
    }
  }

  function shouldBlockWishlistAdd(el) {
    if (!isWishlistAddControl(el)) return false;
    if (isWishlistAddAllControl(el)) return wishlistHasQualifyingItem();
    var productId = productIdFromElement(el);
    if (productId) return Boolean(collectionForProductId(productId));
    if (arrangementFromWishlistItem(el)) return true;
    return isWishlistContext(el);
  }

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      if (!target || !isWishlistAddControl(target)) return;
      if (!shouldBlockWishlistAdd(target)) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      window.__agMinWishlistClick = true;
      clearTimeout(window.__agMinWishlistClickTimer);
      window.__agMinWishlistClickTimer = setTimeout(function () {
        window.__agMinWishlistClick = false;
      }, 2000);
      showWishlistNotice();
    },
    true
  );

  if (window.fetch && !window.fetch.__cartMinimumGate) {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      if (/\/cart\/add/i.test(url) && window.__agMinWishlistClick) {
        window.__agMinWishlistClick = false;
        showWishlistNotice();
        return Promise.reject(new Error("Wishlist add blocked"));
      }
      return originalFetch.apply(this, arguments);
    };
    window.fetch.__cartMinimumGate = true;
  }

  document.addEventListener("theme:cart:change", refresh);
  document.addEventListener("theme:product:added", refresh);
  document.addEventListener("theme:cart:open", refresh);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      refresh();
      lockWishlistButtons();
    });
  } else {
    refresh();
    lockWishlistButtons();
  }

  // Re-apply after theme AJAX rebuilds cart markup and after wishlist apps render.
  var observer = new MutationObserver(function () {
    lockWishlistButtons();
    if (!document.querySelector("[data-cart-page], [data-cart-drawer]")) return;
    bindFormGuards();
    applyUi();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
